export * from "@tanstack/react-query";
export { useIsMutationPending } from "#use-is-mutation-pending";
// Override the upstream `useMutation` with our wrapper that makes `mutationKey`
// mandatory. An explicit named export takes precedence over the `export *` above.
export { useMutation, type UseMutationOptionsWithRequiredKey } from "./use-mutation.ts";
export { usePrefetchQueries, type UsePrefetchQueriesOptions } from "./use-prefetch-queries.ts";
export {
  NavigationQueryActivityContext,
  useInfiniteQuery,
  useQueries,
  useQuery,
  useSuspenseInfiniteQuery,
} from "./use-navigation-focused-queries.ts";
// Our prefetch-aware suspense hooks. `usePrefetchedSuspenseQuery`/`usePrefetchedSuspenseQueries` suspend at
// most once per key prefix (see their doc); the name makes that guarantee explicit at every call
// site. The plain `useSuspenseQuery`/`useSuspenseQueries` names are BANNED below.
export {
  usePrefetchedSuspenseQuery,
  usePrefetchedSuspenseQueries,
} from "./use-suspense-prefetched-queries.ts";

// Ban the stock names. `export *` above would otherwise re-export TanStack's raw
// `useSuspenseQuery`/`useSuspenseQueries` — which suspend on EVERY refetch and tear down the
// boundary on a background update. These explicit exports shadow that re-export with a value whose
// type is a deprecation string, so any `useSuspenseQuery(...)` call is a compile error pointing at
// the prefetched-suspense replacement (rather than silently getting the raw hook).
type UsePrefetchedSuspenseQueryInstead =
  "Use `usePrefetchedSuspenseQuery` from @-/com.npmjs.tanstack__react-query instead — the raw useSuspenseQuery suspends on every refetch.";
type UsePrefetchedSuspenseQueriesInstead =
  "Use `usePrefetchedSuspenseQueries` from @-/com.npmjs.tanstack__react-query instead — the raw useSuspenseQueries suspends on every refetch.";

// oxlint-disable-next-line typescript/no-explicit-any -- deliberate: the value is unusable, only the deprecation-string type matters
export const useSuspenseQuery: UsePrefetchedSuspenseQueryInstead = undefined as any;
// oxlint-disable-next-line typescript/no-explicit-any -- see above
export const useSuspenseQueries: UsePrefetchedSuspenseQueriesInstead = undefined as any;
